import { Box, styled } from "@mui/material"

export const DoughnutContainer = styled(Box)(
  ({ theme: { spacing, breakpoints } }) => ({
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "center",
    rowGap: spacing(4),
    columnGap: spacing(4),
    [breakpoints.up("sm")]: {
      columnGap: spacing(8),
    },
    [breakpoints.up("lg")]: {
      columnGap: spacing(10),
    },
  }),
)
